import React from 'react'

import { CCard, CCardBody, CCardGroup, CCol, CContainer, CRow, CButton } from '@coreui/react'
import { HeaderComponent } from './HeaderComponent'
import { useNavigate } from 'react-router-dom'

const MenuPage = () => {
  const navigate = useNavigate()

  const goToPortalConsultas = () => {
    navigate({
      pathname: '/scl',
    })
  }

  const goToPagoOnline = () => {
    navigate({
      pathname: '/seleccionar-cuentas',
    })
  }

  return (
    <div className="min-vh-100 d-flex flex-row align-items-center">
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={4}>
            <CCardGroup>
              <CCard className="p-4">
                <CCardBody>
                  <HeaderComponent title="Servicios y Consultas en Línea" size="h4" />
                  <CRow>
                    <CCol>
                      <div className="d-grid gap-2">
                        <CButton color="primary" className="px-4" onClick={goToPortalConsultas}>
                          Portal de Consultas
                        </CButton>
                      </div>
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol>
                      <div className="d-grid gap-2 mt-2">
                        <CButton color="primary" className="px-4" onClick={goToPagoOnline}>
                          Pago Online
                        </CButton>
                      </div>
                    </CCol>
                  </CRow>
                </CCardBody>
              </CCard>
            </CCardGroup>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

export default MenuPage
